<div class="container-fluid navBarInvoice">
  <app-header-form [title]="title" [panelOpenState]="panelOpenState" [canShowClearFilter]="true" [canShowPanelFilter]="true" [canExportExcel]="true" (onClearFilterEvent)="clearSearchFilter()"
    (onPanelOpenStateEvent)="onShowFilter($event)" (onExportAsExcelEvent)="exportAsExcel()">
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px">
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Num&eacute;ro de facture</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="inputChanged()" [(ngModel)]="searchCriteriaModel.Number">
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Nom du fournisseur</mat-label>
              <input matInput autocomplete="off" type="text" (keyup)="inputChanged()" [(ngModel)]="searchCriteriaModel.SupplierName">
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>R&eacute;f&eacute;rence 1</mat-label>
              <ng-multiselect-dropdown [settings]="multipleSelectionWithSearchDropdownSettings" [data]="assetsDropdownList" (onFilterChange)="onAssetFilterChange($event)"
                (onDeSelect)="onItemSelect('assets')" (onSelect)="onItemSelect('assets')" placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'assets')"
                (onSelectAll)="onSelectAll($event, 'assets')" [(ngModel)]="assetsSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Soci&eacute;t&eacute; factur&eacute;e</mat-label>
              <ng-multiselect-dropdown [settings]="multipleSelectionWithSearchDropdownSettings" (onFilterChange)="onRecipientEntityFilterChange($event)" [data]="recipientEntitiesDropdownList"
                (onDeSelect)="onItemSelect('recipientEntity')" (onSelect)="onItemSelect('recipientEntity')" (onDeSelectAll)="onSelectAll($event, 'recipientEntity')"
                (onSelectAll)="onSelectAll($event, 'recipientEntity')" placeholder='Sélectionner...' [(ngModel)]="recipientEntitiesSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Factures en cours</mat-label>
              <input matInput [(ngModel)]="searchCriteriaModel.InvoiceInProgress" type="text" hidden>
              <mat-slide-toggle [(ngModel)]="searchCriteriaModel.InvoiceInProgress" name="InvoiceInProgress" class="customToggle" (change)="inputChanged()">
              </mat-slide-toggle>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de r&eacute;ception</mat-label>
              <custom-date-range-input (onDateChange)="dateChangeSearch($event);" typeFrom="FromReceptionDate" [valueFrom]="searchCriteriaModel.FromReceptionDate" typeTo="ToReceptionDate"
                [valueTo]="searchCriteriaModel.ToReceptionDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>Date de facture</mat-label>
              <custom-date-range-input (onDateChange)="dateChangeSearch($event);" typeFrom="FromInvoiceDate" [valueFrom]="searchCriteriaModel.FromInvoiceDate" typeTo="ToInvoiceDate"
                [valueTo]="searchCriteriaModel.ToInvoiceDate"></custom-date-range-input>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Choix filtre type de date</mat-label>
              <ng-multiselect-dropdown [settings]="singleSelectionWithoutSearchDropdownSettings" [data]="processingDateTypesDropdownList" (onSelect)="onDeselectProcessingDateTypesItem($event)"
                (onDeSelect)="onItemSelect($event)" [(ngModel)]="processingDateTypesSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dateStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <mat-label>{{processingDateTypesSelectedItems[0].Label}}</mat-label>
              <custom-date-range-input (onDateChange)="dateChangeSearch($event);" typeFrom="FromProcessingDate" [valueFrom]="searchCriteriaModel.FromProcessingDate" typeTo="ToProcessingDate"
                [valueTo]="searchCriteriaModel.ToProcessingDate"></custom-date-range-input>
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Montant TTC</mat-label>
              <app-custom-amount-range-input (onValueChange)="inputChangedAmount($event);" [valueFrom]="searchCriteriaModel.FromAmount" [valueTo]="searchCriteriaModel.ToAmount">
              </app-custom-amount-range-input>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Situation travaux / Factures</mat-label>
              <ng-multiselect-dropdown [settings]="singleSelectionWithoutSearchDropdownSettings" [data]="workingSituationDropdownList" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'workingSituation')" (onSelectAll)="onSelectAll($event,'workingSituation')"
                [(ngModel)]="workingSituationSelectedItems">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Statuts factures avec BAP EFAC</mat-label>
              <ng-multiselect-dropdown
                [settings]="multipleSelectionWithoutSearchDropdownSettings"
                [data]="voucherValidationStatusDropdownList"
                (onDeSelect)="onItemSelect()"
                (onSelect)="onItemSelect()"
                placeholder='Sélectionner...'
                [(ngModel)]="voucherValidationStatusSelectedItems"
                (onSelectAll)="onSelectAll($event,'voucherValidationStatus')"
                (onDeSelectAll)="onSelectAll($event, 'voucherValidationStatus')"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Statuts factures sans BAP</mat-label>
              <ng-multiselect-dropdown
                [settings]="multipleSelectionWithoutSearchDropdownSettings"
                [data]="invoiceValidationStatusDropdownList"
                (onDeSelect)="onItemSelect()"
                (onSelect)="onItemSelect()"
                placeholder='Sélectionner...'
                [(ngModel)]="invoiceValidationStatusSelectedItems"
                (onSelectAll)="onSelectAll($event,'invoiceValidationStatus')"
                (onDeSelectAll)="onSelectAll($event, 'invoiceValidationStatus')"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Statuts factures avec BAP EFAC Primpromo</mat-label>
              <ng-multiselect-dropdown
                [settings]="multipleSelectionWithoutSearchDropdownSettings"
                [data]="promotionValidationStatusDropdownList"
                (onDeSelect)="onItemSelect()"
                (onSelect)="onItemSelect()"
                placeholder='Sélectionner...'
                [(ngModel)]="promotionValidationStatusSelectedItems"
                (onSelectAll)="onSelectAll($event,'promotionValidationStatus')"
                (onDeSelectAll)="onSelectAll($event, 'promotionValidationStatus')"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Statuts factures en attente</mat-label>
              <ng-multiselect-dropdown
                [settings]="multipleSelectionWithoutSearchDropdownSettings"
                [data]="waitingFlagDropdownList"
                (onDeSelect)="onItemSelect()"
                (onSelect)="onItemSelect()"
                placeholder='Sélectionner...'
                [(ngModel)]="waitingFlagSelectedItems"
                (onSelectAll)="onSelectAll($event,'waitingFlag')"
                (onDeSelectAll)="onSelectAll($event, 'waitingFlag')"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Type de rejet</mat-label>
              <ng-multiselect-dropdown [settings]="multipleSelectionWithoutSearchDropdownSettings" [data]="rejectionFlagDropdownList" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'rejectionFlag')" (onSelectAll)="onSelectAll($event, 'rejectionFlag')" [(ngModel)]="rejectionFlagSelectedItems"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Litige</mat-label>
              <ng-multiselect-dropdown [settings]="singleSelectionWithoutSearchDropdownSettings" [data]="complaintDropdownList" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'complaint')" (onSelectAll)="onSelectAll($event, 'complaint')" [(ngModel)]="complaintSelectedItems"
                class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="search-result">
  <app-invoice-list [(data)]="data" [tableRowsActions]="tableActions" [tableMassActions]="tableMassActions" [onExport]="getInvoiceForExport"
    [onExportDataSourceAvailable]="onExportDataSourceAvailable" [pageSize]="pageSize" [paginatorLength]="paginatorLength" [onSortChange]="onSortChange" [canDownload]="true"
    [onDataSourceChanged]="onDataSourceChanged" [serverPagination]="true" [onPageChange]="onPageChange" [exportFileName]="exportFileName" [configKey]="configKey"
    (onServerSideAllDownload)="onServerSideAllDownload()" [onExportExcelCaller]="onExportExcelCaller" ngDefaultControl>
  </app-invoice-list>
</div>
